<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import { register } from 'swiper/element/bundle';
register();

// 現在のスライド番号
const currentNum = ref(0);

// 周辺の観光名所データ
const visitList = ref([
    {
        id: 'a',
        title: '周辺の観光名所1',
        text: '情に棹させば流される。智に働けば角が立つ。どこへ越しても住みにくいと悟った時、詩が生れて、画が出来る。とかくに人の世は住みにくい。意地を通せば窮屈だ。 とかくに人の世は住みにくい。どこへ越しても住みにくいと悟った時、詩が生れて、画が出来る。意地を通せば窮屈だ。山路を登りながら、こう考えた。智に働けば角が立つ。ど'
    },
    {
        id: 'b',
        title: '周辺の観光名所2',
        text: '情に棹させば流される。智に働けば角が立つ。どこへ越しても住みにくいと悟った時、詩が生れて、画が出来る。とかくに人の世は住みにくい。意地を通せば窮屈だ。 とかくに人の世は住みにくい。どこへ越しても住みにくいと悟った時、詩が生れて、画が出来る。意地を通せば窮屈だ。山路を登りながら、こう考えた。智に働けば角が立つ。ど'
    },
    {
        id: 'c',
        title: '周辺の観光名所3',
        text: '情に棹させば流される。智に働けば角が立つ。どこへ越しても住みにくいと悟った時、詩が生れて、画が出来る。とかくに人の世は住みにくい。意地を通せば窮屈だ。 とかくに人の世は住みにくい。どこへ越しても住みにくいと悟った時、詩が生れて、画が出来る。意地を通せば窮屈だ。山路を登りながら、こう考えた。智に働けば角が立つ。ど'
    },
    {
        id: 'd',
        title: '周辺の観光名所4',
        text: '情に棹させば流される。智に働けば角が立つ。どこへ越しても住みにくいと悟った時、詩が生れて、画が出来る。とかくに人の世は住みにくい。意地を通せば窮屈だ。 とかくに人の世は住みにくい。どこへ越しても住みにくいと悟った時、詩が生れて、画が出来る。意地を通せば窮屈だ。山路を登りながら、こう考えた。智に働けば角が立つ。ど'
    },
]);

// 現在のスライドデータ
const current = computed(() => {
    return visitList.value[currentNum.value];
});

// スライドが切り替わった時に発火
const onSlideChange = (e) => {
    const event = e.detail[0];
    currentNum.value = event.activeIndex; //現在のスライド番号を取得
}
</script>

<template>
<div class="visit-map">
    <div class="visit-map__img">
        <img src="/assets/img/location/visit_map.webp" alt="周辺スポット" width="" height="">
    </div>
    <div class="visit-map__head">
        <div class="visit-map__id">{{ current.id }}.</div>
        <div class="visit-map__titarea">
            <a class="visit-map__arrow is-prev"><span></span></a>
            <h3 class="visit-map__tit">{{ current.title }}</h3>
            <a class="visit-map__arrow is-next"><span></span></a>
        </div>
    </div>
    <swiper-container
    class="visit-map__slider"
    :navigation="{
        nextEl: '.visit-map__arrow.is-next',
        prevEl: '.visit-map__arrow.is-prev',
    }"
    @swiperslidechange="onSlideChange">
        <swiper-slide class="visit-map__slide" v-for="val in visitList" :key="val.id">
            <figure class="visit-map__img">
                <img src="/assets/img/location/dummy.webp" alt="" width="" height="">
            </figure>
            <p class="visit-map__txt">{{ val.text }}</p>
        </swiper-slide>
    </swiper-container>
</div>
</template>